import React from "react";
import PropTypes from "prop-types";

const CustomBadge = ({ count, children, bgcolor }) => {
  const badgeStyle = {
    backgroundColor: bgcolor || "#ff6500", // Use the provided hex color
    color: "#ffffff", // Optional: Ensure the text color contrasts well
  };

  return (
    <div className="position-relative d-inline-block">
      {children}
      {count > 0 && (
        <span
          className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
          style={badgeStyle} // Apply the custom styles
        >
          {count}
          <span className="visually-hidden">unread messages</span>
        </span>
      )}
    </div>
  );
};

CustomBadge.propTypes = {
  count: PropTypes.number.isRequired, // Number displayed in the badge
  children: PropTypes.node.isRequired, // The element the badge is attached to
  bgcolor: PropTypes.string, // Custom color for the badge (e.g., "#FF5733")
};

CustomBadge.defaultProps = {
  bgcolor: "#ff6500", // Default to Bootstrap's primary color
};

export default CustomBadge;
